export const paymentMethod = [
    {
        label:"Thanh toán tại quầy",
        value: 1,
    },
    {
        label:"Chuyển khoản ngân hàng",
        value: 2,
    }
]

export const statusOrder = [
    {
        label:"Chờ lên đơn",
        value: 1,
        background: "#cce5ff",
        color: "#004085"
    },
    {
        label:"Đã lên đơn",
        value: 2,
        background: "#d4edda",
        color: "#155724"
    },
    {
        label:"Huỷ đơn",
        value: 3,
        background: "#f8d7da",
        color: "#721c24"
    }
]

export const statusLead = [
    {
        label:"Chưa tư vấn",
        value: 1,
        background: "#cce5ff",
        color: "#004085"
    },
    {
        label:"Đã tư vấn",
        value: 2,
        background: "#d4edda",
        color: "#155724"
    }
]
